export default "__VITE_ASSET__CEZTSwfj__"